// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * GuidedTour.css — el aspecto del tutorial guiado.
 *
 * Dos ideas:
 *   · El velo es un solo div con un agujero (\`.gt-spot\`) hecho con box-shadow
 *     enorme, así que se ve la aplicación por el hueco. Ni un canvas ni cuatro
 *     divs: una sombra.
 *   · Todo el árbol del tour es \`pointer-events: none\` menos la burbuja y el
 *     botón de restaurar, para que el usuario pueda seguir trabajando mientras
 *     el tutorial está abierto.
 *
 * Los colores salen de las variables del sistema de diseño, así que los skins
 * (claro/oscuro) lo siguen sin tocar nada.
 */

.gt-root {
  position: fixed;
  inset: 0;
  z-index: 10050; /* por encima de la ficha (.dv-overlay, 500) y de los modales (9000) */
  pointer-events: none;
}

.gt-veil {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.gt-spot {
  position: absolute;
  border-radius: 12px;
  pointer-events: none;
  box-shadow:
    0 0 0 9999px rgba(8, 15, 30, 0.66),
    0 0 0 2px rgba(139, 92, 246, 0.9),
    0 0 26px 6px rgba(139, 92, 246, 0.35);
  transition: left 0.28s cubic-bezier(0.22, 0.61, 0.36, 1),
              top 0.28s cubic-bezier(0.22, 0.61, 0.36, 1),
              width 0.28s cubic-bezier(0.22, 0.61, 0.36, 1),
              height 0.28s cubic-bezier(0.22, 0.61, 0.36, 1);
}

/* ── Burbuja ───────────────────────────────────────────────────────────── */
.gt-bubble {
  position: fixed;
  width: 380px;
  max-width: calc(100vw - 32px);
  /* Superficie opaca: un tutorial translúcido deja ver la tabla de detrás y no
     se lee (misma variable que usan los modales de la app). */
  background: var(--bg-surface, var(--bg-card, #fff));
  color: var(--text-primary, #0f172a);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(8, 15, 30, 0.38);
  pointer-events: auto;
  overflow: hidden;
  animation: gt-in 0.22s ease-out;
}

@keyframes gt-in {
  from { opacity: 0; transform: translateY(8px) scale(0.985); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.gt-bubble-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px 6px;
}

.gt-badge {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #6d28d9;
  background: rgba(139, 92, 246, 0.12);
  border-radius: 999px;
  padding: 3px 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gt-counter {
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--text-muted, #64748b);
  font-variant-numeric: tabular-nums;
}

.gt-progress {
  height: 3px;
  background: var(--border, #e2e8f0);
}

.gt-progress span {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #8b5cf6, #6366f1);
  transition: width 0.3s ease;
}

.gt-title {
  margin: 12px 16px 6px;
  font-size: 1.02rem;
  font-weight: 800;
  line-height: 1.25;
  color: var(--text-primary, #0f172a);
}

.gt-body {
  padding: 0 16px;
  font-size: 0.86rem;
  line-height: 1.5;
  color: var(--text-secondary, #334155);
}

.gt-p { margin: 0 0 8px; }
.gt-body .gt-p:last-child { margin-bottom: 2px; }

.gt-list {
  margin: 0 0 8px;
  padding-left: 18px;
}

.gt-list li { margin-bottom: 3px; }

.gt-code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.8rem;
  background: var(--bg-toolbar, #f1f5f9);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 4px;
  padding: 1px 5px;
}

.gt-tip {
  display: flex;
  gap: 8px;
  margin: 10px 16px 0;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(245, 158, 11, 0.12);
  border: 1px solid rgba(245, 158, 11, 0.35);
  font-size: 0.78rem;
  line-height: 1.45;
  color: var(--text-primary, #0f172a);
}

.gt-tip-flag {
  flex: 0 0 auto;
  font-size: 0.62rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #92400e;
  padding-top: 1px;
}

.gt-note {
  margin: 10px 16px 0;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 0.78rem;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.32);
  color: var(--text-primary, #0f172a);
}

.gt-note--warn {
  background: rgba(239, 68, 68, 0.1);
  border-color: rgba(239, 68, 68, 0.32);
}

.gt-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  padding: 12px 14px 10px;
}

.gt-foot-left,
.gt-foot-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.gt-btn {
  font-size: 0.76rem;
  font-weight: 600;
  border-radius: 8px;
  padding: 5px 10px;
  border: 1px solid var(--border, #e2e8f0);
  background: var(--bg-card, #fff);
  color: var(--text-secondary, #334155);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.gt-btn:hover:not(:disabled) { border-color: #8b5cf6; color: #6d28d9; }
.gt-btn:disabled { opacity: 0.45; cursor: default; }

.gt-btn--ghost.is-on {
  background: rgba(139, 92, 246, 0.14);
  border-color: #8b5cf6;
  color: #6d28d9;
}

.gt-btn--primary {
  background: linear-gradient(135deg, #7c3aed, #4f46e5);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.35);
}

.gt-btn--primary:hover { color: #fff; transform: translateY(-1px); }

.gt-btn--ok {
  background: linear-gradient(135deg, #059669, #10b981);
  border-color: transparent;
  color: #fff;
}

.gt-status {
  min-height: 20px;
  padding: 0 14px 10px;
  font-size: 0.72rem;
}

.gt-status-ok { color: #059669; font-weight: 700; }
.gt-status-wait { color: var(--text-muted, #64748b); }

/* ── Botón flotante cuando el tutorial está minimizado ─────────────────── */
.gt-restore {
  position: fixed;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border: 1px solid rgba(139, 92, 246, 0.5);
  border-radius: 999px;
  background: var(--bg-surface, var(--bg-card, #fff));
  color: var(--text-primary, #0f172a);
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  pointer-events: auto;
  box-shadow: 0 12px 30px rgba(8, 15, 30, 0.32);
}

.gt-restore:hover { border-color: #8b5cf6; }

.gt-restore-icon { font-size: 1rem; }

/* ── Modo demo: panel inferior ancho ───────────────────────────────────────
   En la demo el tutorial hace los clics, así que lo que importa es VER la
   pantalla. El texto baja a una franja pegada al borde inferior y deja libre
   toda la zona central: la información no se tapa nunca.                    */
.gt-dock {
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: min(1180px, calc(100vw - 24px));
  background: var(--bg-surface, var(--bg-card, #fff));
  color: var(--text-primary, #0f172a);
  border: 1px solid var(--border, #e2e8f0);
  border-bottom: none;
  border-radius: 14px 14px 0 0;
  box-shadow: 0 -18px 46px rgba(8, 15, 30, 0.36);
  pointer-events: auto;
  overflow: hidden;
  animation: gt-up 0.24s ease-out;
}

@keyframes gt-up {
  from { opacity: 0; transform: translate(-50%, 14px); }
  to   { opacity: 1; transform: translate(-50%, 0); }
}

.gt-dock-bar {
  height: 3px;
  background: var(--border, #e2e8f0);
}

.gt-dock-bar span {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #8b5cf6, #6366f1);
  transition: width 0.3s ease;
}

.gt-dock-inner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 18px 14px;
}

.gt-dock-left { min-width: 0; flex: 1 1 auto; }

.gt-dock-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.gt-body--dock {
  padding: 0;
  font-size: 0.84rem;
  max-height: 4.8em;      /* dos o tres líneas: el resto se puede expandir */
  overflow: auto;
}

.gt-dock .gt-title {
  margin: 2px 0 4px;
  font-size: 0.98rem;
}

.gt-live {
  font-size: 0.7rem;
  font-weight: 800;
  color: #dc2626;
  animation: gt-blink 1.4s ease-in-out infinite;
}

.gt-paused {
  font-size: 0.7rem;
  font-weight: 800;
  color: var(--text-muted, #64748b);
}

@keyframes gt-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

.gt-doing {
  margin-top: 6px;
  font-size: 0.76rem;
  font-weight: 700;
  color: #7c3aed;
}

.gt-dock-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex: 0 0 auto;
  max-width: 320px;
}

.gt-play { min-width: 108px; }

/* ── Ratón que se mueve solo ──────────────────────────────────────────────
   Viaja con una transición hasta el elemento del paso antes de pulsarlo: se ve
   POR DÓNDE VA (menú lateral incluido) y no solo el resultado del clic.      */
.gt-cursor {
  position: fixed;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  margin: -2px 0 0 -2px;
  pointer-events: none;
  z-index: 10070;
  filter: drop-shadow(0 3px 6px rgba(8, 15, 30, 0.45));
  transition: transform 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
  will-change: transform;
}

.gt-cursor::after {
  content: '';
  position: absolute;
  left: 2px;
  top: 2px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.45), rgba(139, 92, 246, 0) 70%);
  transform: translate(-50%, -50%);
  pointer-events: none;
}

/* ── Onda del clic que da la demo ──────────────────────────────────────── */
.gt-pulse {
  position: fixed;
  width: 26px;
  height: 26px;
  margin: -13px 0 0 -13px;
  border-radius: 50%;
  border: 3px solid rgba(139, 92, 246, 0.9);
  background: rgba(139, 92, 246, 0.28);
  pointer-events: none;
  animation: gt-ping 0.62s ease-out forwards;
}

@keyframes gt-ping {
  0%   { transform: scale(0.4); opacity: 1; box-shadow: 0 0 0 0 rgba(139, 92, 246, 0.55); }
  100% { transform: scale(2.1); opacity: 0; box-shadow: 0 0 0 22px rgba(139, 92, 246, 0); }
}

/* Aviso suave (para los pasos que la demo no hace sola). */
.gt-note--soft {
  background: rgba(139, 92, 246, 0.1);
  border-color: rgba(139, 92, 246, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/tutorial/GuidedTour.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE;;AAEF;EACE,eAAe;EACf,QAAQ;EACR,cAAc,EAAE,sEAAsE;EACtF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB;;;yCAGuC;EACvC;;;4DAG0D;AAC5D;;AAEA,6EAA6E;AAC7E;EACE,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B;8DAC4D;EAC5D,mDAAmD;EACnD,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,6CAA6C;EAC7C,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,QAAQ,eAAe,EAAE;AACzB,4BAA4B,kBAAkB,EAAE;;AAEhD;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,cAAc,kBAAkB,EAAE;;AAElC;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,qCAAqC;EACrC,eAAe;EACf,+EAA+E;AACjF;;AAEA,+BAA+B,qBAAqB,EAAE,cAAc,EAAE;AACtE,mBAAmB,aAAa,EAAE,eAAe,EAAE;;AAEnD;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,WAAW;EACX,8CAA8C;AAChD;;AAEA,yBAAyB,WAAW,EAAE,2BAA2B,EAAE;;AAEnE;EACE,qDAAqD;EACrD,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;AAClD,kBAAkB,iCAAiC,EAAE;;AAErD,6EAA6E;AAC7E;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yCAAyC;EACzC,oBAAoB;EACpB,mDAAmD;EACnD,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA,oBAAoB,qBAAqB,EAAE;;AAE3C,mBAAmB,eAAe,EAAE;;AAEpC;;;8EAG8E;AAC9E;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,sCAAsC;EACtC,mDAAmD;EACnD,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,4BAA4B;EAC5B,8CAA8C;EAC9C,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,gCAAgC,EAAE;EACrD,OAAO,UAAU,EAAE,6BAA6B,EAAE;AACpD;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA,gBAAgB,YAAY,EAAE,cAAc,EAAE;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB,OAAO,kDAAkD;EAC1E,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW,gBAAgB,EAAE;;AAE7B;;+EAE+E;AAC/E;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,oDAAoD;EACpD,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wFAAwF;EACxF,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,6EAA6E;AAC7E;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE,4CAA4C,EAAE;EACxF,OAAO,qBAAqB,EAAE,UAAU,EAAE,4CAA4C,EAAE;AAC1F;;AAEA,2DAA2D;AAC3D;EACE,mCAAmC;EACnC,qCAAqC;AACvC","sourcesContent":["/**\r\n * GuidedTour.css — el aspecto del tutorial guiado.\r\n *\r\n * Dos ideas:\r\n *   · El velo es un solo div con un agujero (`.gt-spot`) hecho con box-shadow\r\n *     enorme, así que se ve la aplicación por el hueco. Ni un canvas ni cuatro\r\n *     divs: una sombra.\r\n *   · Todo el árbol del tour es `pointer-events: none` menos la burbuja y el\r\n *     botón de restaurar, para que el usuario pueda seguir trabajando mientras\r\n *     el tutorial está abierto.\r\n *\r\n * Los colores salen de las variables del sistema de diseño, así que los skins\r\n * (claro/oscuro) lo siguen sin tocar nada.\r\n */\r\n\r\n.gt-root {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 10050; /* por encima de la ficha (.dv-overlay, 500) y de los modales (9000) */\r\n  pointer-events: none;\r\n}\r\n\r\n.gt-veil {\r\n  position: absolute;\r\n  inset: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.gt-spot {\r\n  position: absolute;\r\n  border-radius: 12px;\r\n  pointer-events: none;\r\n  box-shadow:\r\n    0 0 0 9999px rgba(8, 15, 30, 0.66),\r\n    0 0 0 2px rgba(139, 92, 246, 0.9),\r\n    0 0 26px 6px rgba(139, 92, 246, 0.35);\r\n  transition: left 0.28s cubic-bezier(0.22, 0.61, 0.36, 1),\r\n              top 0.28s cubic-bezier(0.22, 0.61, 0.36, 1),\r\n              width 0.28s cubic-bezier(0.22, 0.61, 0.36, 1),\r\n              height 0.28s cubic-bezier(0.22, 0.61, 0.36, 1);\r\n}\r\n\r\n/* ── Burbuja ───────────────────────────────────────────────────────────── */\r\n.gt-bubble {\r\n  position: fixed;\r\n  width: 380px;\r\n  max-width: calc(100vw - 32px);\r\n  /* Superficie opaca: un tutorial translúcido deja ver la tabla de detrás y no\r\n     se lee (misma variable que usan los modales de la app). */\r\n  background: var(--bg-surface, var(--bg-card, #fff));\r\n  color: var(--text-primary, #0f172a);\r\n  border: 1px solid var(--border, #e2e8f0);\r\n  border-radius: 14px;\r\n  box-shadow: 0 24px 60px rgba(8, 15, 30, 0.38);\r\n  pointer-events: auto;\r\n  overflow: hidden;\r\n  animation: gt-in 0.22s ease-out;\r\n}\r\n\r\n@keyframes gt-in {\r\n  from { opacity: 0; transform: translateY(8px) scale(0.985); }\r\n  to   { opacity: 1; transform: translateY(0) scale(1); }\r\n}\r\n\r\n.gt-bubble-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding: 10px 14px 6px;\r\n}\r\n\r\n.gt-badge {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n  color: #6d28d9;\r\n  background: rgba(139, 92, 246, 0.12);\r\n  border-radius: 999px;\r\n  padding: 3px 10px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.gt-counter {\r\n  font-size: 0.7rem;\r\n  font-weight: 700;\r\n  color: var(--text-muted, #64748b);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.gt-progress {\r\n  height: 3px;\r\n  background: var(--border, #e2e8f0);\r\n}\r\n\r\n.gt-progress span {\r\n  display: block;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #8b5cf6, #6366f1);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.gt-title {\r\n  margin: 12px 16px 6px;\r\n  font-size: 1.02rem;\r\n  font-weight: 800;\r\n  line-height: 1.25;\r\n  color: var(--text-primary, #0f172a);\r\n}\r\n\r\n.gt-body {\r\n  padding: 0 16px;\r\n  font-size: 0.86rem;\r\n  line-height: 1.5;\r\n  color: var(--text-secondary, #334155);\r\n}\r\n\r\n.gt-p { margin: 0 0 8px; }\r\n.gt-body .gt-p:last-child { margin-bottom: 2px; }\r\n\r\n.gt-list {\r\n  margin: 0 0 8px;\r\n  padding-left: 18px;\r\n}\r\n\r\n.gt-list li { margin-bottom: 3px; }\r\n\r\n.gt-code {\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\r\n  font-size: 0.8rem;\r\n  background: var(--bg-toolbar, #f1f5f9);\r\n  border: 1px solid var(--border, #e2e8f0);\r\n  border-radius: 4px;\r\n  padding: 1px 5px;\r\n}\r\n\r\n.gt-tip {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin: 10px 16px 0;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  background: rgba(245, 158, 11, 0.12);\r\n  border: 1px solid rgba(245, 158, 11, 0.35);\r\n  font-size: 0.78rem;\r\n  line-height: 1.45;\r\n  color: var(--text-primary, #0f172a);\r\n}\r\n\r\n.gt-tip-flag {\r\n  flex: 0 0 auto;\r\n  font-size: 0.62rem;\r\n  font-weight: 800;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: #92400e;\r\n  padding-top: 1px;\r\n}\r\n\r\n.gt-note {\r\n  margin: 10px 16px 0;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  font-size: 0.78rem;\r\n  background: rgba(59, 130, 246, 0.12);\r\n  border: 1px solid rgba(59, 130, 246, 0.32);\r\n  color: var(--text-primary, #0f172a);\r\n}\r\n\r\n.gt-note--warn {\r\n  background: rgba(239, 68, 68, 0.1);\r\n  border-color: rgba(239, 68, 68, 0.32);\r\n}\r\n\r\n.gt-foot {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  padding: 12px 14px 10px;\r\n}\r\n\r\n.gt-foot-left,\r\n.gt-foot-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.gt-btn {\r\n  font-size: 0.76rem;\r\n  font-weight: 600;\r\n  border-radius: 8px;\r\n  padding: 5px 10px;\r\n  border: 1px solid var(--border, #e2e8f0);\r\n  background: var(--bg-card, #fff);\r\n  color: var(--text-secondary, #334155);\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;\r\n}\r\n\r\n.gt-btn:hover:not(:disabled) { border-color: #8b5cf6; color: #6d28d9; }\r\n.gt-btn:disabled { opacity: 0.45; cursor: default; }\r\n\r\n.gt-btn--ghost.is-on {\r\n  background: rgba(139, 92, 246, 0.14);\r\n  border-color: #8b5cf6;\r\n  color: #6d28d9;\r\n}\r\n\r\n.gt-btn--primary {\r\n  background: linear-gradient(135deg, #7c3aed, #4f46e5);\r\n  border-color: transparent;\r\n  color: #fff;\r\n  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.35);\r\n}\r\n\r\n.gt-btn--primary:hover { color: #fff; transform: translateY(-1px); }\r\n\r\n.gt-btn--ok {\r\n  background: linear-gradient(135deg, #059669, #10b981);\r\n  border-color: transparent;\r\n  color: #fff;\r\n}\r\n\r\n.gt-status {\r\n  min-height: 20px;\r\n  padding: 0 14px 10px;\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.gt-status-ok { color: #059669; font-weight: 700; }\r\n.gt-status-wait { color: var(--text-muted, #64748b); }\r\n\r\n/* ── Botón flotante cuando el tutorial está minimizado ─────────────────── */\r\n.gt-restore {\r\n  position: fixed;\r\n  bottom: 22px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 9px 16px;\r\n  border: 1px solid rgba(139, 92, 246, 0.5);\r\n  border-radius: 999px;\r\n  background: var(--bg-surface, var(--bg-card, #fff));\r\n  color: var(--text-primary, #0f172a);\r\n  font-size: 0.82rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  pointer-events: auto;\r\n  box-shadow: 0 12px 30px rgba(8, 15, 30, 0.32);\r\n}\r\n\r\n.gt-restore:hover { border-color: #8b5cf6; }\r\n\r\n.gt-restore-icon { font-size: 1rem; }\r\n\r\n/* ── Modo demo: panel inferior ancho ───────────────────────────────────────\r\n   En la demo el tutorial hace los clics, así que lo que importa es VER la\r\n   pantalla. El texto baja a una franja pegada al borde inferior y deja libre\r\n   toda la zona central: la información no se tapa nunca.                    */\r\n.gt-dock {\r\n  position: fixed;\r\n  left: 50%;\r\n  bottom: 0;\r\n  transform: translateX(-50%);\r\n  width: min(1180px, calc(100vw - 24px));\r\n  background: var(--bg-surface, var(--bg-card, #fff));\r\n  color: var(--text-primary, #0f172a);\r\n  border: 1px solid var(--border, #e2e8f0);\r\n  border-bottom: none;\r\n  border-radius: 14px 14px 0 0;\r\n  box-shadow: 0 -18px 46px rgba(8, 15, 30, 0.36);\r\n  pointer-events: auto;\r\n  overflow: hidden;\r\n  animation: gt-up 0.24s ease-out;\r\n}\r\n\r\n@keyframes gt-up {\r\n  from { opacity: 0; transform: translate(-50%, 14px); }\r\n  to   { opacity: 1; transform: translate(-50%, 0); }\r\n}\r\n\r\n.gt-dock-bar {\r\n  height: 3px;\r\n  background: var(--border, #e2e8f0);\r\n}\r\n\r\n.gt-dock-bar span {\r\n  display: block;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #8b5cf6, #6366f1);\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.gt-dock-inner {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  padding: 12px 18px 14px;\r\n}\r\n\r\n.gt-dock-left { min-width: 0; flex: 1 1 auto; }\r\n\r\n.gt-dock-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.gt-body--dock {\r\n  padding: 0;\r\n  font-size: 0.84rem;\r\n  max-height: 4.8em;      /* dos o tres líneas: el resto se puede expandir */\r\n  overflow: auto;\r\n}\r\n\r\n.gt-dock .gt-title {\r\n  margin: 2px 0 4px;\r\n  font-size: 0.98rem;\r\n}\r\n\r\n.gt-live {\r\n  font-size: 0.7rem;\r\n  font-weight: 800;\r\n  color: #dc2626;\r\n  animation: gt-blink 1.4s ease-in-out infinite;\r\n}\r\n\r\n.gt-paused {\r\n  font-size: 0.7rem;\r\n  font-weight: 800;\r\n  color: var(--text-muted, #64748b);\r\n}\r\n\r\n@keyframes gt-blink {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.35; }\r\n}\r\n\r\n.gt-doing {\r\n  margin-top: 6px;\r\n  font-size: 0.76rem;\r\n  font-weight: 700;\r\n  color: #7c3aed;\r\n}\r\n\r\n.gt-dock-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-end;\r\n  flex: 0 0 auto;\r\n  max-width: 320px;\r\n}\r\n\r\n.gt-play { min-width: 108px; }\r\n\r\n/* ── Ratón que se mueve solo ──────────────────────────────────────────────\r\n   Viaja con una transición hasta el elemento del paso antes de pulsarlo: se ve\r\n   POR DÓNDE VA (menú lateral incluido) y no solo el resultado del clic.      */\r\n.gt-cursor {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  width: 24px;\r\n  height: 24px;\r\n  margin: -2px 0 0 -2px;\r\n  pointer-events: none;\r\n  z-index: 10070;\r\n  filter: drop-shadow(0 3px 6px rgba(8, 15, 30, 0.45));\r\n  transition: transform 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);\r\n  will-change: transform;\r\n}\r\n\r\n.gt-cursor::after {\r\n  content: '';\r\n  position: absolute;\r\n  left: 2px;\r\n  top: 2px;\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 50%;\r\n  background: radial-gradient(circle, rgba(139, 92, 246, 0.45), rgba(139, 92, 246, 0) 70%);\r\n  transform: translate(-50%, -50%);\r\n  pointer-events: none;\r\n}\r\n\r\n/* ── Onda del clic que da la demo ──────────────────────────────────────── */\r\n.gt-pulse {\r\n  position: fixed;\r\n  width: 26px;\r\n  height: 26px;\r\n  margin: -13px 0 0 -13px;\r\n  border-radius: 50%;\r\n  border: 3px solid rgba(139, 92, 246, 0.9);\r\n  background: rgba(139, 92, 246, 0.28);\r\n  pointer-events: none;\r\n  animation: gt-ping 0.62s ease-out forwards;\r\n}\r\n\r\n@keyframes gt-ping {\r\n  0%   { transform: scale(0.4); opacity: 1; box-shadow: 0 0 0 0 rgba(139, 92, 246, 0.55); }\r\n  100% { transform: scale(2.1); opacity: 0; box-shadow: 0 0 0 22px rgba(139, 92, 246, 0); }\r\n}\r\n\r\n/* Aviso suave (para los pasos que la demo no hace sola). */\r\n.gt-note--soft {\r\n  background: rgba(139, 92, 246, 0.1);\r\n  border-color: rgba(139, 92, 246, 0.3);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
